import { useMutation } from '@apollo/client';
import registerViaAppleMutation from './RegisterViaAppleMutation';

const RegisterViaAppleConnectorApollo = ({ children }) => {
  const [mutate, { loading }] = useMutation(registerViaAppleMutation);

  const createRegisterViaApple = async (token) => {
    const response = await mutate({
      variables: {
        token,
      },
    });

    return response;
  };

  return children({
    registerViaApple: createRegisterViaApple,
    loading,
  });
};

export default RegisterViaAppleConnectorApollo;
